module.exports = __webpack_public_path__ + "static/media/Dayly_ios_1.9239a26a.jpg";